import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { genVWUnit, isDefined } from '../util';
const style = require('./index.module.scss');
let Icon = class Icon extends Vue {
    get iconId() {
        return `#icon-${this.name}`;
    }
    render() {
        const styleProps = {};
        isDefined(this, 'width') && Object.assign(styleProps, {
            width: genVWUnit(this.width)
        });
        isDefined(this, 'height') && Object.assign(styleProps, {
            height: genVWUnit(this.height)
        });
        return (<svg style={styleProps} on={this.$listeners} class={[this.className, style.svgIcon]}>
        <use xlinkHref={this.iconId} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'/>
      </svg>);
    }
};
__decorate([
    Prop({
        type: String,
        required: true,
    })
], Icon.prototype, "name", void 0);
__decorate([
    Prop(Number)
], Icon.prototype, "width", void 0);
__decorate([
    Prop(Number)
], Icon.prototype, "height", void 0);
__decorate([
    Prop(String)
], Icon.prototype, "iconColor", void 0);
__decorate([
    Prop(String)
], Icon.prototype, "className", void 0);
Icon = __decorate([
    Component
], Icon);
export default Icon;
//# sourceMappingURL=index.jsx.map